/** @format */

import {Trans, useTranslation} from 'react-i18next';

import {BillingDiscountPeriod} from 'graphql/generated/types';

import {CardData, PartnerDiscount} from 'pages/Tariffs/types';
import {getDiscountPercent} from 'pages/Tariffs/helpers/getDiscountPercent';

import {DISCOUNT_PERIODS} from 'pages/Tariffs/constants';

import {SegmentedRadioButton} from 'components/buttons/SegmentedGroup/SegmentedRadioButton';

import {SegmentedBox} from 'components/buttons/SegmentedGroup/SegmentedBox';

import {Cards} from '../Cards';
import {ID_PARTNER_DISCOUNT_NOTE} from './constants';
import {DiscountBadge, NoteText, Root} from './styles';

interface Props {
  duration: BillingDiscountPeriod;
  onChangeDuration: (value: BillingDiscountPeriod) => void;
  cardsData: CardData[];
  partnerDiscount: PartnerDiscount | null;
}

const BusinessTariffs = ({duration, onChangeDuration, cardsData, partnerDiscount}: Props) => {
  const {t} = useTranslation();

  return (
    <Root>
      <SegmentedBox>
        <SegmentedRadioButton
          active={duration === DISCOUNT_PERIODS.TWELVE_MONTHS}
          activeBgColor='linear-gradient(180deg, #4C753B 0%, #60914A 100%)'
          onClick={() => onChangeDuration(DISCOUNT_PERIODS.TWELVE_MONTHS)}
        >
          {t('plurals.months', {count: 12})}
          <DiscountBadge
            active={duration === DISCOUNT_PERIODS.TWELVE_MONTHS}
            inactiveColor='#4C753B'
            activeColor='linear-gradient(180deg, #60914A 0%, #7DB664 100%)'
          >
            -25%
          </DiscountBadge>
        </SegmentedRadioButton>

        <SegmentedRadioButton
          active={duration === DISCOUNT_PERIODS.SIX_MONTHS}
          activeBgColor='linear-gradient(180deg, #177768 0%, #1E9481 100%)'
          onClick={() => onChangeDuration(DISCOUNT_PERIODS.SIX_MONTHS)}
        >
          {t('plurals.months', {count: 6})}
          <DiscountBadge
            active={duration === DISCOUNT_PERIODS.SIX_MONTHS}
            inactiveColor='#177768'
            activeColor='linear-gradient(180deg, #1E9481 0%, #39BAA4 100%)'
          >
            -15%
          </DiscountBadge>
        </SegmentedRadioButton>

        <SegmentedRadioButton
          active={duration === DISCOUNT_PERIODS.THREE_MONTHS}
          activeBgColor='linear-gradient(180deg, #316E9F 0%, #3E88C5 100%)'
          onClick={() => onChangeDuration(DISCOUNT_PERIODS.THREE_MONTHS)}
        >
          {t('plurals.months', {count: 3})}
        </SegmentedRadioButton>
      </SegmentedBox>

      {partnerDiscount && (
        <NoteText data-testid={ID_PARTNER_DISCOUNT_NOTE}>
          {t(
            'По промокоду партнёра «{{partnerName}}» действует скидка {{percent}}% на первый платёж — цены указаны с её учётом',
            {
              partnerName: partnerDiscount.partnerName,
              percent: getDiscountPercent(partnerDiscount.percent),
            },
          )}
        </NoteText>
      )}

      <Cards duration={duration} cardsData={cardsData} partnerDiscount={partnerDiscount} />

      <NoteText>
        <Trans>Цены тарифных планов указаны за один календарный месяц и не облагаются НДС</Trans>
      </NoteText>
    </Root>
  );
};

export {BusinessTariffs};
